export { default as Checkbox } from "./checkbox";
export { default as Slider } from "./slider";
export { default as StyledInput } from "./styledInput";
